import React, { useContext } from 'react';
import useSectionStyles from './styles';
import Icon from '../../icon';
import { useTheme } from '../../theme/theming';
import NextImageRenderer from '../nextImageRenderer';
import PageContext from '../../contexts/pageContext';
export default function Footer({ data, orgId }) {
  const theme = useTheme();

  const { isCustomWebsite, extraProps } = useContext(PageContext);

  const classes = useSectionStyles({ isCustomWebsite });

  return (
    <footer
      className={
        data.metadata.isCpBranding
          ? `${classes.section}`
          : `${classes.section} ${classes.sectionNoBranding}`
      }
    >
      <div
        className={
          data.metadata.isCpBranding
            ? `${classes.upperContainer}`
            : `${classes.upperContainer} ${classes.upperContainerNoBranding}`
        }
      >
        <div className={classes.upperContainerItem1}>
          {/* <img src={data?.logo?.metadata?.url} ref={data?.logo?.refSetter} /> */}
          <div className={classes.upperContainerItem1Img}>
            <NextImageRenderer
              src={data?.logo?.metadata?.url}
              ref={data?.logo?.refSetter}
              className={classes.footerLogoImage}
            />
          </div>
        </div>
        <div className={classes.upperContainerItem2}>
          {data?.address?.metadata.value &&
          data?.address?.metadata.value !== '<br>' ? (
            <p className={classes.addressContainer}>
              <span className={classes.addressImg}>
                <Icon
                  name={'Location'}
                  color={theme.palette.font.primary}
                  width={'18px'}
                />
              </span>
              <span
                className={classes.addressText}
                ref={data?.address?.refSetter}
                dangerouslySetInnerHTML={{
                  __html: data?.address?.metadata.value
                }}
              />
            </p>
          ) : null}
          {data?.phone?.metadata.value &&
          data?.phone?.metadata.value !== '<br>' ? (
            <p className={classes.addressContainer}>
              <span className={classes.addressImg}>
                <Icon
                  name={'Phone'}
                  color={theme.palette.font.primary}
                  width={'18px'}
                />
              </span>
              <span
                className={classes.addressText}
                ref={data?.phone?.refSetter}
                dangerouslySetInnerHTML={{
                  __html: data?.phone?.metadata.value
                }}
              />
            </p>
          ) : null}
          {data?.email?.metadata.value &&
          data?.email?.metadata.value !== '<br>' ? (
            <p className={classes.addressContainer}>
              <span className={classes.addressImg}>
                <Icon
                  name={'Email'}
                  color={theme.palette.font.primary}
                  width={'18px'}
                />
              </span>
              <span
                className={classes.addressText}
                ref={data?.email?.refSetter}
                dangerouslySetInnerHTML={{
                  __html: data?.email?.metadata.value
                }}
              />
            </p>
          ) : null}
        </div>
        <div className={classes.upperContainerItem3}>
          {data?.facebookLink?.metadata?.value ? (
            <button
              ref={data?.facebookLink?.refSetter}
              className={classes.socialMediaCta}
              onClick={() => {
                window.open(data?.facebookLink?.metadata?.value, '_blank');
              }}
            >
              <Icon
                name={'Facebook Solid'}
                color={theme.palette.background.default}
                width={'16px'}
                height={'16px'}
              />
            </button>
          ) : null}
          {data?.twitterLink?.metadata?.value ? (
            <button
              ref={data?.twitterLink?.refSetter}
              className={classes.socialMediaCta}
              onClick={() => {
                window.open(data?.twitterLink?.metadata?.value, '_blank');
              }}
            >
              <Icon
                name={'Twitter Solid'}
                color={theme.palette.background.default}
                width={'16px'}
                height={'16px'}
              />
            </button>
          ) : null}
          {data?.instagramLink?.metadata?.value ? (
            <button
              ref={data?.instagramLink?.refSetter}
              className={classes.socialMediaCta}
              onClick={() => {
                window.open(data?.instagramLink?.metadata?.value, '_blank');
              }}
            >
              <Icon
                name={'Instagram'}
                color={theme.palette.background.default}
                width={'16px'}
                height={'16px'}
              />
            </button>
          ) : null}
          {data?.telegramLink?.metadata?.value ? (
            <button
              ref={data?.telegramLink?.refSetter}
              className={classes.socialMediaCta}
              onClick={() => {
                window.open(data?.telegramLink?.metadata?.value, '_blank');
              }}
            >
              <Icon
                name={'Telegram'}
                color={theme.palette.background.default}
                width={'16px'}
                height={'16px'}
              />
            </button>
          ) : null}
          {data?.youtubeLink?.metadata?.value ? (
            <button
              ref={data?.youtubeLink?.refSetter}
              className={classes.socialMediaCta}
              onClick={() => {
                window.open(data?.youtubeLink?.metadata?.value, '_blank');
              }}
            >
              <Icon
                name={'YouTube'}
                color={theme.palette.background.default}
                width={'16px'}
                height={'16px'}
              />
            </button>
          ) : null}
        </div>
      </div>

      {data.metadata.isCpBranding ? (
        <div className={classes.lowerContainer}>
          <div className={classes.bottomLeftText}>
            &copy; {new Date().getFullYear()} All Rights Reserved
          </div>
          <div className={classes.poweredByContainer}>
            <p>Powered by</p>
            <a
              title="Powered by Classplus"
              target="_blank"
              href="https://classplusapp.com/"
              className={classes.poweredDiv}
            >
              {/* <img
              alt="classplus"
              src={'https://storage.googleapis.com/coursewebview/logo.png'}
            /> */}

              <NextImageRenderer
                src={'https://storage.googleapis.com/coursewebview/logo.png'}
                alt="classplus"
                className={classes.poweredDivImg}
              />
            </a>
          </div>
        </div>
      ) : null}

      {orgId === 643870 || extraProps?.org_id === 643870 ? (
        <div
          style={{ display: 'flex', alignSelf: 'start', marginBottom: '10px' }}
        >
          © Samko Automotive Solution
        </div>
      ) : null}

      {orgId === 510746 || extraProps?.org_id === 510746 ? (
        <div
          style={{ display: 'flex', alignSelf: 'start', marginBottom: '10px' }}
        >
          © Bhushan Ramchandra Gawarepatil
        </div>
      ) : null}

      {orgId === 374619 || extraProps?.org_id === 374619 ? (
        <div
          style={{ display: 'flex', alignSelf: 'start', marginBottom: '10px' }}
        >
          ©️ Leaverage Consultants Private Limited
        </div>
      ) : null}
    </footer>
  );
}
